import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./apps/page";
import Rootlayout from "./apps/_root";
import GameWindowRoot, {GameWindow} from "./apps/window/game";


const route = createBrowserRouter([
    {
        path: "/",
        element: <Rootlayout/>,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "/gameLobby",
                element: <GameWindowRoot />,
                children: [
                    { path: ":vendor/", element: <GameWindow/> }
                ]
            }
            // {
            //     path: "/lobby",
            //     element: <Lobby />,
                // children: [
                //     { path: "/slot", element: <SlotLobby/> }
                // ]
            // }
        ]
    }
])




ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <RouterProvider router={route} />
);
